import React, { PureComponent } from 'react'
import Overlay, { StopPropagation } from '@ynap/overlay'
import { Portal } from 'react-portal'
import PropTypes from 'prop-types'
import { Button, SimpleAsyncButton } from '@ynap/button'
import BEMHelper from '@ynap/bem-helper'
import { ImageWithSkeleton } from '@ynap/image'
import { CART_LIMIT_QTY_REDUCED, RESERVATION_NUMBER_INVALID } from 'app/state/cart-state/actions/cartRectification'

const bem = new BEMHelper('CartRectifyOverlay')

class RemovedItemsOverlay extends PureComponent {
    static propTypes = {
        soldoutItems: PropTypes.array,
        lineItems: PropTypes.array,
        title: PropTypes.string,
        clearRectification: PropTypes.func,
        messages: PropTypes.shapeOf({
            cartRectification: PropTypes.shapeOf({
                btn: PropTypes.func.isRequired,
                bagUpdated: PropTypes.func.isRequired,
                description: PropTypes.func.isRequired,
                title: PropTypes.func.isRequired,
            }),
        }),
        rectification: PropTypes.object,
        history: PropTypes.object.isRequired,
        setCheckoutNotification: PropTypes.object.isRequired,
        locale: PropTypes.shapeOf({
            id: PropTypes.string.isRequired,
        }),
        addItemsToWishlist: PropTypes.func.isRequired,
        checkoutError: PropTypes.string,
    }

    state = {
        wishlistLoading: false,
    }

    allItemsOutOfStock = () => {
        const { lineItems, lineItemsIncludingRemoved, soldoutItems } = this.props
        if (soldoutItems && lineItems?.length === 0) {
            return true
        }

        if (soldoutItems?.length === lineItemsIncludingRemoved?.length) {
            const matchingItems = []
            soldoutItems?.forEach((soldoutItem) => {
                lineItemsIncludingRemoved.filter((lineItemIncludingRemoved) =>
                    lineItemIncludingRemoved.partNumber === soldoutItem.partNumber ? matchingItems.push(soldoutItem) : 0
                )
            })
            if (matchingItems.length === soldoutItems?.length) return true
        }
        return false
    }

    handleClick = () => {
        const { clearRectification, history, rectification, messages, setCheckoutNotification, locale } = this.props
        const { redirect } = rectification
        clearRectification()
        if (!this.allItemsOutOfStock()) {
            redirect && history.push(redirect)
            return setCheckoutNotification('info', messages.cartRectification.bagUpdated(), { autoHideDelay: 3000 })
        }

        history.push(`/${locale.id}/checkout?clearMessages=true`)
    }

    handleWishlistClick = async () => {
        this.setState({ wishlistLoading: false })
        const { soldoutItems, addItemsToWishlist } = this.props
        const partNumbers = soldoutItems.map((product) => ({ partNumber: product.partNumber }))
        try {
            addItemsToWishlist(partNumbers)
        } catch (e) {
            /*eslint-disable*/
        }
        this.setState({ wishlistLoading: true })
        this.handleClick()
    }

    getRemovedItemsMessages = (messages, rectification) => {
        if (rectification.rectificationType === RESERVATION_NUMBER_INVALID) {
            return {
                title: messages.cartRectification.bagUpdated(),
                description: messages.cartRectification.RESERVATION_NUMBER_INVALID(),
            }
        } else if (rectification.rectificationType === CART_LIMIT_QTY_REDUCED) {
            return {
                title: messages.cartRectification.bagUpdated(),
                description: rectification.affectedItems > 1 ? messages.cartRectification.quantity.multiple() : messages.cartRectification.quantity.single(),
            }
        }
        return {
            title: messages.cartRectification.bagUpdated(),
            description: messages.cartRectification.CART_ITEM_INVALID(),
        }
    }

    render() {
        const { soldoutItems = [], messages, rectification, userStatus, checkoutError } = this.props
        if (!rectification || !soldoutItems.length) return null
        const allItemsOutOfStock = this.allItemsOutOfStock()
        const onClose = this.handleClick

        const loggedIn = userStatus === 'R'

        const removedItemsMessages = this.getRemovedItemsMessages(messages, rectification)

        return (
            <Portal>
                <Overlay title={removedItemsMessages?.title} onClose={onClose} handleBodyClick={onClose} className={bem()}>
                    <StopPropagation>
                        <div className={bem('description')}>{removedItemsMessages?.description}</div>
                        {loggedIn ? (
                            <SimpleAsyncButton
                                className={bem('addToWishlist')}
                                onClick={() => this.handleWishlistClick()}
                                type="secondary"
                                loading={this.state.wishlistLoading}
                                copy={messages.cartRectification.wishlist()}
                            />
                        ) : null}
                        <ul className={bem('productsContainer')}>
                            {soldoutItems.map((each) => {
                                const { partNumber, brand, name, image } = each
                                return (
                                    <li key={partNumber} className={bem('product')}>
                                        <div className={bem('imageContainer')}>
                                            <ImageWithSkeleton src={image?.url} imageSrcset={image?.srcSet} alt={name} computeAttributes={false} />
                                        </div>
                                        <div className={bem('productDetails')}>
                                            <div className={bem('productDesigner')}>{brand}</div>
                                            <div className={bem('productName')}>{name}</div>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                        <Button className={bem('button')} onClick={this.handleClick} type="primary">
                            {messages.cartRectification.outOfStock.primary({ allItemsOutOfStock })}
                        </Button>
                    </StopPropagation>
                </Overlay>
            </Portal>
        )
    }
}

export default RemovedItemsOverlay
